import { Settings } from '../app/shared/models/settings';

// The list of which env maps to which file can be found in `.angular-cli.json`.
const settings: Settings = {
  apiProtocol: 'https',
  apiHost: 'api.oman.afaqy.pro',
  jsonHost: 'http://localhost:4200',
  stompConfig: {
    url: 'https://stageavl.afaqy.sa:12163/socket',
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
    heartbeat_in: 0,
    heartbeat_out: 50000,
    reconnect_delay: 0,
    debug: true,
  },
  pagination: {
    limit: 1000,
  },
  AVL_Login_URL: 'https://oman.afaqy.pro/auth/login',
  WSStompUnitsURL: 'https://signal-live-update.avl.oman.afaqy.pro/socket/',

  intervalGap: 15,
  signalIntervalTimeout: 60,
  // apiPort:3000
};
export const environment = {
  production: false,
  settings,
  // avlToken:
  //   'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS5hZmFxeS5zYS9hdXRoL2xvZ2luX2FzIiwiaWF0IjoxNzAyOTgzMTk1LCJleHAiOjE3MDU1NzUxOTUsIm5iZiI6MTcwMjk4MzE5NSwianRpIjoicTRLNFYzNGNJNFh1TEQzZiIsInN1YiI6IjYwODAwYTc4YzYyMGYzMmI1YzVkZDU3NiIsInBydiI6IjI3MGVjZmM3ZWEzZWQ5MzdlYTg0OTM2MmEzYTUwOTEwYzZkOGNlNGYiLCJsb2dpbl9hc19pZCI6IjYzMzA0MTcwMjhhZDIwNDJjZDE1M2U0YyJ9.2cuyDH27njCWcZEWjwFQrIQvusT820v_faE_93-fbcc',
};
